import React from 'react';
import LegislativnyMaterialItem from '../../model/pracovnyKrok/LegislativnyMaterialItem';

export interface PracovnyKrokLegislativnyMaterialContextContent {
  material?: LegislativnyMaterialItem,
  setMaterial?: (LegislativnyMaterialItem) => void,
  loadingMaterial?: boolean;
  setLoadingMaterial?: (isLoading: boolean) => void,
}

export default React.createContext<PracovnyKrokLegislativnyMaterialContextContent>({
  material: undefined,
  setMaterial: undefined,
  loadingMaterial: undefined,
  setLoadingMaterial: undefined,
});
